<div class="fc-study-news-preview">
    <div class="fc-study-news-preview-wrapper" *ngIf="articleDetail">
        <div class="header-detail">
            <p class="last-updated" aria-label="Last Updated Time">Last Updated / {{ articleDetail.updatedDate | date: 'EEEE, dd-MMMM-y HH:mm' : 'UTC' }}</p>
            <p class="headline">{{ articleDetail.headline }}</p>
            <p class="subheadline">{{ articleDetail.subhead }}</p>
        </div>
        <div class="promoImage" aria-label="Promo Image" [style.backgroundImage]="'url(' + articleDetail.promoImage + ')'"></div>
        <div class="body-detail" >
            <p class="lead-paragraph">{{ articleDetail.leadParagraph }}</p>
            <div class="body-text" [innerHTML]="safeBodyText"></div>
        </div>
    </div>
</div>
